import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';

var Config = require('../../../config');

class Criterials extends Component{
	constructor(props){
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.getBloodComponent = this.getBloodComponent.bind(this);
		this.newPetition   = this.newPetition.bind(this);
		this.getPetitionType = this.getPetitionType.bind(this);
		
		this.onSearch = this.onSearch.bind(this);

		var aux_date = new Date();

		this.state = {
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio : "",
			end_folio 	: "",

			blood_bags  : [],
			blood_bags_id:"",
			blood_bags_name:"",
			blood_required:false,
			submenu 	: "",
			blood_components:[],
			blood_component_id: "",
			
			//fractioning:[],
			results:[],
			filter_option:"all",
			petitions:[],
			petition_type:"",
			details:false,
			view:'actives',

			convoke_places:[],
			convoke_places_id:"all",
			health_facilities:[],
			health_facilities_id:"",

			status: "all",
			status_list:[],
			option:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		this.setState({health_facilities_id: sessionStorage.getItem('health_facilities_id')});

		var submenu = /*this.props.search !== "" ? this.props.search : */this.props.match.path.replace('/', '');

		switch(submenu){

			case 'centrifuge':
				this.setState({
					start_date:"",
					end_date:"",
					submenu:submenu
				});
				break;
			case 'cryoprecipitate':
				this.setState({
					start_date:"",
					end_date:"",
					submenu:submenu
				});
				this.getCryoprecipitateComponent();
				break;
			case 'modify_component/new':
				this.setState({submenu:submenu});
				this.getBloodComponent('blood_component/has_unit');
				break;
			case 'aliquots/new':
				this.setState({
					start_date:"",
					end_date:"",
					submenu:submenu
				});
				this.getBloodComponent('blood_component/has_unit_alicuots');
				break;
			case 'plasma':
				this.setState({submenu:submenu});
				break;
			case 'warehouse/units':
				fetch(Config.default.apiGateway.URL+'lookups/order_by?type=unit_status&option=name', {
					method: 'get',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							status_list: response
						});
					}
				});


				fetch(Config.default.apiGateway.URL+'health_facilities', {
					method: 'GET',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						
						this.setState({
							health_facilities: response
						});
					}
				});
			case 'discard_units':
			case 'lock_units/new':
				this.setState({submenu:submenu, blood_component_id:"all"});
				this.getBloodComponent('lookups?type=blood_component_type&option=actives&order=true');
				break;
			case 'warehouse/storeUnits':
				this.setState({submenu:submenu});
				this.getBloodComponent('lookups?type=blood_component_type&option=actives&order=true');
				break;
			case 'petition_register':
				this.setState({
					start_date:"",
					end_date:"",
					submenu:submenu
				});
				this.getPetitionType();
				break;
			case 'fractioning':
				fetch(Config.default.apiGateway.URL+'convoke_places?option=active', {
					method : 'get',
					headers: new Headers({
						'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
						'Accept'	 	: 'application/json',
						'Content-Type' 	: 'application/json'
					})
				})
				.then(res => {
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(result) {
		                swal('¡Error', result, 'error');
		              });
		            }})
				.then(response => {
					if(response !== undefined){
						this.setState({convoke_places:response});
					}				
				});
				this.setState({submenu:submenu});
				this.getBloodBags();
				break;

			default:
				this.setState({submenu:submenu});
				this.getBloodBags();
				break;
		}
		
	}

	componentDidUpdate(){
		var submenu = /*this.props.search !== "" ? this.props.search : */this.props.match.path.replace('/', '');
		if(submenu !== this.state.submenu){
			this.setState({submenu: submenu});

			if(submenu === 'petition_register'){
				this.getPetitionType();
			}
		}
	}

	getBloodComponent(url){
		fetch(Config.default.apiGateway.URL+url, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					blood_components: response
				});

				//busqueda al cambiar el valor del combo de componente
				if( this.state.submenu !== 'aliquots/new' && 
					this.state.submenu !== 'cryoprecipitate' &&
					this.state.submenu !== 'warehouse/storeUnits' &&
					this.state.submenu !== 'warehouse/units' &&
					this.state.submenu !== 'discard_units' &&
					this.state.submenu !== 'lock_units/new'
				){
					this.props.sendData(response, 'components');
				}else if(this.state.submenu === 'warehouse/units'){
					//this.onSearch();
				}
			}				
		});
	}

	getBloodBags(){
		//blood_bags
		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					blood_bags: response
				});
			}						
		});
	}

	getCryoprecipitateComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/for_crios', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({
					blood_components: response
				});
				if(this.state.submenu !== 'aliquots/new' && this.state.submenu !== 'cryoprecipitate'){
					this.props.sendData(response, 'components');
				}
			}
		});
	}

	getPetitionType(view){
		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=petition_group_types&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					petitions:response, 
					petition_type:'all',
					view: view === undefined ? 'actives' :	
						this.state.start_date === '' ? 'actives' : 'all'
				});

				this.onSearch('actives');
			}
		});
		/*
		fetch(Config.default.apiGateway.URL+'petition_type?option=active', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({petitions:response});
			}
		});*/
	}

	handleChange(e){
		if(e.target.name === 'blood_bags_id'){
			var index = e.nativeEvent.target.selectedIndex;
			this.setState({
				[e.target.name]: e.target.value,
				blood_bags_name:e.nativeEvent.target[index].text,
				blood_required:false
			});
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				[e.target.name]: e.target.value,
				blood_required:false
			});

			if(this.state.submenu === 'modify_component/new'){
				this.props.clear();
				setTimeout(function(){
					//this.onSearch();
				}.bind(this), 500);
				
			}
		}else if(e.target.name === 'status'){
			if(this.state.submenu === 'warehouse/units'){
				this.setState({
					[e.target.name]: e.target.value
				});
				setTimeout(()=>{
					//this.onSearch();
				}, 500);
				
			}
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}

		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && e.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	onSearch(type){
		switch(this.state.submenu ){
			case "fractioning":
				if(this.state.convoke_places_id !== ""){
					this.getDataSearch(
						'donations/division_program', 
						'&blood_bags_id='+this.state.blood_bags_id+'&convoke_places_id='+this.state.convoke_places_id);
				}else{
					swal('Error', 'Debe seleccionar un lugar de colecta', 'error');
				}	
				break;
				
			case "modify_component/new":
				this.getDataSearch('units/transformation_process', '&blood_component_id='+this.state.blood_component_id);
				break;
			case 'aliquots/new':
				this.getDataSearch('units/alicuots_process', '&blood_component_id='+this.state.blood_component_id);
				break;
			case 'centrifuge':
				var required = this.requireInput();
				
				if(required === 4){
					swal('Error', 'Debe ingresar al menos un criterio de búsqueda.', 'error');
				}else{
					this.getDataSearch('donations/centrifuge_program', '');
				}
				break;
			case 'cryoprecipitate':
				this.getDataSearch('units/cryoprecipitate_process', '&blood_component_id='+this.state.blood_component_id);
				break;
			case 'plasma':
				this.getDataSearch('units/plasma_process', '');
				break;
			case 'warehouse/units':
				this.getDataSearch('units/storage', '&component_type='+this.state.blood_component_id+
					'&status='+this.state.status)
				break;
			case 'warehouse/storeUnits':
				this.getDataSearch('units/storage_ubication', '&component_type='+this.state.blood_component_id)
				break;
			case 'discard_units':
			case 'lock_units/new':
				this.getDataSearch('units/discard_search_block', '&component_type='+this.state.blood_component_id)
				break;

			case 'petition_register':


				/*if(this.state.start_date !== "" || this.state.end_date !== "" || this.state.start_folio !== "" || this.state.end_folio !== "" ||
					this.state.petition_type !== "all"){
					this.setState({view:'all'});
				}else{
					this.setState({view:'actives'});
				}*/
				this.setState({view:type === undefined ? 'actives' : type});
				setTimeout(()=>{
					this.getDataSearch('petitions/get_list', this.state.view);
				},500)
				
				/*
				if(this.state.petition_type === ""){
					this.props.getList('all');	
				}else{
					this.props.getList(this.state.petition_type);
				}*/
				
				break;
		}
	}

	getDataSearch(apiUrl, blood_id){
		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');
		var url = "";
		var method = 'GET';
		var obj = '';
		var headers = {
			method : method,
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}
		var error_date = '';

		if(submenu === 'warehouse/units'){
			var health = this.state.health_facilities_id;
			url = apiUrl+'?health_facilities_id='+health+ blood_id

		}else if(submenu === 'discard_units' || submenu === 'lock_units/new'){
			url = apiUrl+'?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+blood_id+'&start_folio='+
					this.state.start_folio+'&end_folio='+this.state.end_folio+'&option='+this.state.filter_option

		}else if(submenu === 'petition_register'){
			obj = {
				start_date: this.state.start_date,
				end_date: this.state.end_date,
				start_folio: this.state.start_folio,
				end_folio: this.state.end_folio,
				option: (this.state.petition_type === '' ? 'all' : this.state.petition_type),
				view:blood_id,
				health_facilities_id:sessionStorage.getItem('health_facilities_id')
			}
			method = 'POST';
			url = apiUrl;
			headers = {
				method : method,
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}

			if(blood_id !== 'actives'){
				document.getElementById('start_date').classList.remove('error');
				document.getElementById('end_date').classList.remove('error');

				if(this.state.start_date === ""){
					error_date = 'error';
					document.getElementById('start_date').classList.add('error');
				}

				if(this.state.end_date === ""){
					error_date = 'error';
					document.getElementById('end_date').classList.add('error');
				}
				
				
			}

		}else{
			url = apiUrl+'?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
				'&start_date='+this.state.start_date+'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+
				'&end_folio='+this.state.end_folio + blood_id
		}

		
		if(this.state.submenu === 'fractioning' || this.state.submenu === 'modify'){
			if(this.state.start_date === "" || this.state.end_date === ""){
				error_date = 'error';
			}
		}

		if(this.state.blood_component_id !== "" || this.state.blood_bags_id !== "" || this.state.submenu === 'plasma' 
			|| this.state.submenu === 'centrifuge' || this.state.submenu === 'petition_register'){
			if(error_date === ''){
				this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+url, headers)
				.then(res => {
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(result) {
		                swal('¡Error!', result, 'error');
		              });
		            }})
				.then(response => {
					this.props.waiting.handleClose();
					if(response !== undefined){
						//NO TODOS LOS MENUS REGRESAN LA MISMA ESTRUCTURA DE DATOS
						if(this.state.submenu === "centrifuge" || this.state.submenu == "aliquots/new" || this.state.submenu === "modify_component/new"
							|| this.state.submenu === "cryoprecipitate" || this.state.submenu === "plasma"){
							if(response.length === 0){
								swal("Búsqueda sin resultados", "", 'warning');
							}
						} 

						if(this.state.submenu !== 'aliquots/new' || this.state.submenu !== 'modify_component/new'){
							if(response.message !== undefined && response.message !== "")
								swal('Error', response.message, 'error')
						}

						this.setState({
							results: response,
							blood_required:false
						});

						if(this.state.submenu !== 'modify_component/new'){
							this.props.sendData(this.state.results);
						}else {
							this.props.sendData(this.state.results, 'modify');
						}
					}
				});
			}else{
				swal('Error', 'Debe seleccionar una fecha', 'error');
			}
				
		}else{
			this.setState({
				blood_required:true
			});
			if(this.state.submenu === 'fractioning'){
				swal('Error', 'Tipo de bolsa requerido', 'error');
			}else if(this.state.submenu === 'discard_units'){
				swal('Error', 'Tipo requerido', 'error');
			}else{
				swal('Error', 'Componente requerido.', 'error');	
			}
			
		}
	}

	requireInput(){
		const select = document.querySelector('div.criterials');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = 0;
	    
	    inputs.forEach(input => {
	    	if(input.value === ''){
	    		console.log(input)
	    		isFormValid++;
	    	}
	    });

	    return isFormValid;
	}

	newPetition(){
		switch(this.state.submenu){
			case 'petition_register':
				this.props.history.push("/petition_register/new");
				break;
		}
  		
  	}

  	

	render(){
		const {t} = this.props;
		var submenu = /*this.props.search !== "" ? this.props.search : */this.props.match.path.replace('/', '');
		
		return (
			<div className="col-xs-12 criterials">
				{submenu !== 'warehouse/units' ?
				<div>
					{submenu !== 'discard_units' && submenu !== 'lock_units/new' ?
						submenu === 'modify_component/new' && this.props.search === 'fecha' ?
							<div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Fecha Desde</span>
									<input className="form-control" type="date" name="start_date" id="start_date" onChange={this.handleChange} 
										value={this.state.start_date || ""} 
										onKeyPress={(e) => this.props.validate(e)} autoFocus={true} />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Fecha Hasta</span>
									<input className="form-control" type="date" name="end_date" id="end_date" onChange={this.handleChange} 
										value={this.state.end_date || ""} 
										onKeyPress={(e) => this.props.validate(e)} />
								</div>
							</div>
						: submenu !== 'modify_component/new' ?
							<div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Fecha Desde</span>
									<input className="form-control" type="date" name="start_date" id="start_date" onChange={this.handleChange} 
										value={this.state.start_date || ""} 
										onKeyPress={(e) => this.props.validate(e)} autoFocus={true} />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Fecha Hasta</span>
									<input className="form-control" type="date" name="end_date" id="end_date" onChange={this.handleChange} 
										value={this.state.end_date || ""} 
										onKeyPress={(e) => this.props.validate(e)} />
								</div>
							</div>
						: null
					:null}
					
					{this.state.submenu === 'modify_component/new' && this.props.search === 'folio' ?
						<div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Folio U Desde</span>
								<input className="form-control" type="text" name="start_folio" id="start_folio" onChange={this.handleChange} 
									value={this.state.start_folio || ""} onKeyPress={(e) => this.props.validate(e)} 
								/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Folio U Hasta</span>
								<input className="form-control" type="text" name="end_folio" id="end_folio" onChange={this.handleChange} 
									value={this.state.end_folio || ""} onKeyPress={(e) => this.props.validate(e)}
								/>
							</div>
						</div>
					:this.state.submenu !== 'modify_component/new' ?
						<div>
							<div className={this.state.submenu !== 'fractioning' ? "col-xs-12 col-sm-2" : "col-xs-12 col-sm-1"}>
								<span className="span-min">
									{this.state.submenu !== 'modify_component/new' && this.state.submenu !== 'aliquots/new' ? 
										'Folio Desde' 
									: 'Folio U Desde'}
								</span>
								<input className="form-control" type="text" name="start_folio" id="start_folio" onChange={this.handleChange} 
									value={this.state.start_folio || ""} onKeyPress={(e) => this.props.validate(e)} 
									style={this.state.submenu !== 'fractioning' ? {} : {padding:'3px'}} />
							</div>
							<div className={this.state.submenu !== 'fractioning' ? "col-xs-12 col-sm-2" : "col-xs-12 col-sm-1"}>
								<span className="span-min">
									{this.state.submenu !== 'modify_component/new' && this.state.submenu !== 'aliquots/new' ? 
										'Folio Hasta' 
									: 'Folio U Hasta'}
								</span>
								<input className="form-control" type="text" name="end_folio" id="end_folio" onChange={this.handleChange} 
									value={this.state.end_folio || ""} onKeyPress={(e) => this.props.validate(e)}
									style={this.state.submenu !== 'fractioning' ? {} : {padding:'3px'}} />
							</div>
						</div>
					:null}
					
				</div>
				: null}
			
				{this.state.submenu !== 'plasma' && this.state.submenu !== 'centrifuge' ?

					<div className={this.state.submenu === 'petition_register' || this.state.submenu === 'petition_samples' ? 
							"col-xs-12 col-sm-2" : this.state.submenu !== 'fractioning' ? "col-xs-12 col-sm-3" : "col-xs-12 col-sm-2"} 
						style={this.state.submenu !== 'cryoprecipitate' ? {paddingTop:"0px"} : {paddingTop:"18px"}}>	
						<span className="span-min">
							{this.state.submenu !== 'cryoprecipitate' ? 
								this.state.submenu === 'aliquots/new' ? 
									'Componente a Modificar' 
								: this.state.submenu === 'warehouse/units' || this.state.submenu === 'warehouse/storeUnits'?
									'Componente Sanguíneo'
								: this.state.submenu === 'discard_units' || submenu === 'lock_units/new' ?
									'Componente'
								: this.state.submenu === 'petition_register' ?
									'Tipo de Petición'
								: this.state.submenu === 'modify_component/new' ?
									'Tipo de Componente'
								: 'Tipo de Bolsa' : ''}
						</span>
						{	this.state.submenu === 'modify_component/new' || 
							this.state.submenu === 'aliquots/new' || 
							this.state.submenu === 'cryoprecipitate' ||
							this.state.submenu === 'warehouse/units' ||
							this.state.submenu === 'warehouse/storeUnits' ||
							this.state.submenu === 'discard_units' ||
							this.state.submenu === 'lock_units/new'
							 ?
								<select className={this.state.blood_required ? "form-control error" : "form-control"} name="blood_component_id" value={this.state.blood_component_id || ""}
									onChange={this.handleChange} onKeyPress={(e) => this.props.validate(e)} >
									<option value="">Seleccione...</option>
									{this.state.submenu === 'warehouse/units' ||
									this.state.submenu === 'warehouse/storeUnits' ||
									this.state.submenu === 'discard_units' ||
									this.state.submenu === 'lock_units/new' ?
										<option value="all">TODOS</option>
									:null}

									{this.state.submenu === 'cryoprecipitate' ?
										this.state.blood_components.map(function(t) {
											return <option key={t.id} value={t.id} >{t.component}</option>;
										})

									: 	this.state.submenu === 'warehouse/units' ||
										this.state.submenu === 'warehouse/storeUnits' ||
										this.state.submenu === 'discard_units' ||
										this.state.submenu === 'lock_units/new' ?
											this.state.blood_components.map(function(t) {
												return <option key={t.id} value={t.key} >{t.name}</option>;
											})
									
									:	this.state.blood_components.map(function(t) {
												return <option key={t.component.id} value={t.component.id} >{t.component.component}</option>;
											})
									}
								</select>
						: this.state.submenu === 'petition_register' || this.state.submenu === 'petition_samples' ?
							<select className="form-control" name="petition_type" id="petition_type" 
								value={this.state.petition_type || ""} onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								{this.state.petitions.map((p, i)=>{
									return <option key={i} value={p.key}>
										{p.name}
									</option>
								})}
							</select>
						:
							<select className={this.state.blood_required ? "form-control error" : "form-control"} name="blood_bags_id" 
								value={this.state.blood_bags_id || ""} onChange={this.handleChange} onKeyPress={(e) => this.props.validate(e)}>
								<option value="">Seleccione...</option>
								{this.state.blood_bags.map(function(t) {
									return <option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>;
								})}
							</select>
						}			
					</div>
				:null
				}


				{this.state.submenu === 'warehouse/units' ?
					<div>
						<div className="col-xs-12 col-sm-3 form-group status">
							<span className="span-min">Estatus</span>
							<select className="form-control" name="status" id="status" 
								value={this.state.status} onChange={this.handleChange}>
								<option value="all">TODOS</option>
								{this.state.status_list.map((s, i)=>{
									return <option key={i} value={s.key}>
										{s.name}
									</option>
								})}
							</select>
						</div>
						
					</div>
				: null}

				{this.state.submenu === 'discard_units' ||  this.state.submenu === 'lock_units/new'?
					<div className="col-xs-12 col-sm-3">
						<span className="span-min">Tipo</span>
						<select className="form-control" name="filter_option" id="filter_option" value={this.state.filter_option || ""} onChange={this.handleChange}>
							<option value="all">TODAS</option>
							<option value="expired">SÓLO CADUCADAS</option>
						</select>

					</div>
				: null}

				{this.state.submenu === 'fractioning'?
					<div className="col-xs-12 col-sm-3">
						<span className="span-min">
							Lugar Colecta
						</span>
						<select className="form-control" name="convoke_places_id" id="convoke_places_id" 
							value={this.state.convoke_places_id || ""} onChange={this.handleChange} required>
							<option value="">Seleccione...</option>
							<option value="all">TODOS</option>
							{this.state.convoke_places.map((t,i)=>(
			                  <option key={i}  value={t.convoke_places.id} >
			                  	{t.convoke_places.name} 
			                  </option>
			                ))}
						</select>

					</div>
				: null}

				{this.state.submenu === 'warehouse/units'?
					<div className="col-xs-12 col-sm-3">
						<span className="span-min">
							Almacén
						</span>
						<select className="form-control" name="health_facilities_id" id="health_facilities_id" 
							value={this.state.health_facilities_id || ""} onChange={this.handleChange} required
							disabled={sessionStorage.getItem('matriz') !== '1'}>
							<option value="">Seleccione...</option>
							<option value="all">TODOS</option>
							{this.state.health_facilities.map((t,i)=>(
			                  <option key={i}  value={t.id} >
			                  	{t.name} 
			                  </option>
			                ))}
						</select>

					</div>
				: null}

				

				{this.state.submenu === 'warehouse/units' &&
					<div className="col-xs-12 col-sm-2" style={{marginTop:"20px"}}>
						<input type="checkbox" name="details" onChange={this.props.details} checked={this.state.details} />
						<span className="span-min" style={{marginLeft:"5px"}}>Ver Detalles</span>
					</div>
				}


				
				<div className="col-xs-12 col-sm-1" style={this.state.submenu === 'petition_register' ? {paddingTop:"12px", textAlign:"right"} : {paddingTop:"12px"}}>
        			<button style={{fontSize:"1em"}} id="criterial_btn_search" className="btn btn-info" 
        				type="button" onClick={this.state.submenu === 'petition_register' ? (e)=>this.onSearch('all') : this.onSearch.bind(this)} /*onKeyPress={(e) => this.validateInput(e)}*/>
        				{t('content.generics.buttons.search')}
        			</button>
				</div>
				
				

				{this.state.submenu === 'petition_register' ?
					<div className="col-xs-12 col-sm-1" style={{paddingTop:"12px"}}>
						<button type="button" className="btn btn-info" style={{fontSize:"1em"}}
							onClick={this.newPetition} disabled={!this.props.task_petitions.create} >
							{t('content.generics.buttons.new')}
						</button>
					</div>
				: null}
				

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Criterials);